export const CLOUD_API_URL =
  'https://us-central1-f2b-base.cloudfunctions.net/api';
export const GUEST_BASE_URL = `https://f2bportfolio.com/guest/`;
export const EMBED_BASE_URL = `https://f2bportfolio.com/embed/`;
